var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('cs-preloader-overlay', {
    attrs: {
      "loading": _vm.loading
    }
  }, [_c('div', {
    staticClass: "identity-screen",
    style: {
      backgroundImage: _vm.backgroundImage
    }
  }, [_c('div', {
    staticClass: "main-container"
  }, [_c('div', {
    staticClass: "title-container",
    class: {
      approved: _vm.isApproved
    }
  }, [_vm.isApproved ? [_c('capusta-title', {
    attrs: {
      "icon-outside": ""
    }
  }), _c('div', {
    staticClass: "approved-title"
  }, [_c('div', {
    staticClass: "approved-status"
  }, [_vm._v(_vm._s(_vm.customerTitle))]), _c('div', {
    staticClass: "approved-info"
  }, [_vm._v(_vm._s(_vm.customerInfo))])])] : _c('capusta-title', {
    attrs: {
      "title": _vm.$t('common.identification'),
      "icon-outside": ""
    }
  }, [_c('template', {
    slot: "description"
  }, [_c('div', {
    staticClass: "identity-description",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('raise.transfer.limits.and.unblock.payout'))
    }
  })])], 2)], 2), _c('div', {
    staticClass: "content-container"
  }, [_vm.isAwaitingVerification ? _c('identity-awaiting') : _vm.isApproved ? _c('identity-approved', {
    on: {
      "reset": _vm.onReset
    }
  }) : _c('identity-form', {
    attrs: {
      "value": _vm.identification,
      "countries": _vm.countries
    },
    on: {
      "change-country": _vm.onChangeCountry,
      "submit": _vm.onSend
    }
  })], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }